export const NO_SCROLLBARS_CLASS = "no-scrollbars";
